import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { OrbitProvider } from './store'
import { initTelegram } from './telegram'
import { isStandaloneBrowser, StandaloneAuth } from './components/StandaloneAuth'
import './index.css'

// Telegram WebApp инициализируется до рендера (ready/expand/цвета).
initTelegram()

class ErrorBoundary extends React.Component<{ children: React.ReactNode }, { hasError: boolean; message: string }> {
  override state = { hasError: false, message: '' }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, message: error?.message ?? String(error) }
  }

  override componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[O.R.B.I.T. Web] render error:', error, info)
  }

  override render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100dvh',
            background: '#0a0f1a',
            color: '#e8eaed',
            fontFamily: 'system-ui, sans-serif',
            padding: '1.5rem',
            textAlign: 'center'
          }}
        >
          <div>
            <h1 style={{ fontSize: '1.4rem', marginBottom: '0.75rem' }}>O.R.B.I.T. — ошибка</h1>
            <pre
              style={{
                background: '#0d1321',
                border: '1px solid #1a2a4a',
                borderRadius: '8px',
                padding: '1rem',
                textAlign: 'left',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                fontSize: '0.8rem',
                color: '#ffb800',
                marginBottom: '1rem'
              }}
            >
              {this.state.message}
            </pre>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: '0.6rem 1.2rem',
                background: '#1a73e8',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                fontSize: '0.95rem'
              }}
            >
              Перезагрузить
            </button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}

function Root() {
  const [authenticated, setAuthenticated] = React.useState(!isStandaloneBrowser())
  React.useEffect(() => {
    if (!isStandaloneBrowser()) return
    fetch('/api/session', { credentials: 'include', cache: 'no-store' })
      .then(response => setAuthenticated(response.ok))
      .catch(() => setAuthenticated(false))
  }, [])
  if (isStandaloneBrowser() && !authenticated) return <StandaloneAuth onAuthenticated={() => setAuthenticated(true)} />
  return <OrbitProvider><App /></OrbitProvider>
}

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <Root />
    </ErrorBoundary>
  </React.StrictMode>
)
